import { Link as RouterLink } from 'react-router-dom'
import { Link } from '@mui/material'
import { MdArrowBack } from 'react-icons/md'
import { RegistrationGroupCompactType } from '../utils/sharedTypes'

type BackToGroupLinkPropsType = {
  registrationGroup?: RegistrationGroupCompactType | null
}

// Rendu uniquement quand la Registration en cours est rattachée à un RegistrationGroup (cf.
// `Registration.registration_group`, en cours de déploiement incrémental) : sans ça, il n'y a nulle
// part où revenir. Utilisé à la fois dans `Layout` (funnel standard) et dans les pages qui codent leur
// propre header (Alma, Stripe, BankTransfer, OpcoValidation).
const BackToGroupLink = ({ registrationGroup }: BackToGroupLinkPropsType) => {
  if (!registrationGroup) return null

  return (
    <Link
      component={RouterLink}
      to={`/groupe/${registrationGroup.global_id}`}
      underline="hover"
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}
    >
      <MdArrowBack size={14} />
      Retour à mes inscriptions
    </Link>
  )
}

export default BackToGroupLink
